export interface MarketVideo {
  title: string;
  author: string;
  videoId: string;
}

export const marketVideos: MarketVideo[] = [
  {
    title: 'Conteúdo Audiovisual - Ouro Preto',
    author: 'Ouro Preto',
    videoId: '1175244792',
  },
  {
    title: 'Conteúdo Audiovisual - Multiplike',
    author: 'Multiplike',
    videoId: '1175244551',
  },
  {
    title: 'Conteúdo Audiovisual - Celcoin',
    author: 'Celcoin',
    videoId: '1175244823',
  },
  {
    title: 'Conteúdo Audiovisual - Vertrau',
    author: 'Vertrau',
    videoId: '1175244724',
  },
];
